import styled from '@emotion/styled';
import React from 'react';
import { colorBlue } from 'styles/base';

const StyledAnchor = styled.a`
    border-radius: 10px;
    margin: 5px 0;
    &:hover {
      box-shadow: 0 0 11px rgba(33,33,33,.2); 
    }
`;

const Card = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 15px 4px;
  width: 400px;
`;

const Image = styled.i`
   width: 65px;
   text-align: center;
`;

const DescriptionHolder = styled.div`
`;

const Text = styled.div`
  color: #444;
  font-size: 13px;
  padding-right: 5px;
`;

export default class HomePageCard extends React.Component {

  static defaultProps = {
    external: true,
    primary: false
  };

  render() {
    const iconStyle = this.props.primary ? `fa ${this.props.iconClass} fa-5x` : `fa ${this.props.iconClass} fa-3x`;
    const Title = styled.div`
      color: ${this.props.primary ? colorBlue : '#2A2C2B'};
      font-size: ${this.props.primary ? '19px' : '15px'};
      font-weight: 900;
    `;

    const ImageHolder = styled.div`
      color: ${this.props.primary ? colorBlue : '#2A2C2B'};
      margin: 0 12px 0 10px;
      display: flex;
      align-items: flex-start;
`;

    return (
      <StyledAnchor href={this.props.link} target="_blank" rel="noopener noreferrer">
        <Card>
          <ImageHolder>
            <Image className={iconStyle} aria-hidden="true" />
          </ImageHolder>
          <DescriptionHolder>
            <Title>{this.props.title}</Title>
            <Text>{this.props.description}</Text>
          </DescriptionHolder>
        </Card>
      </StyledAnchor>
    );


  }
}



// WEBPACK FOOTER //
// ./src/components/page/pcm-home/HomePageCard.js